import React from 'react'

import SingleInput from '../Fields/SingleInput'
import Signature from '../Fields/Signature'

import classes from './layout.css'

const ModuleTwo = (props)  => {
	return (
		<div>
			<p><strong>If patient is a minor, parent or guardian signature is required.</strong></p>

			<div className={classes.Section}>
				<SingleInput
					name={"relationshipToPatient"}
					inputType={"text"}
					controlFunc={props.addToForm}
					placeholder={"Relationship to Patient"}
					value={props.consentForm.relationshipToPatient}
				/>
				<SingleInput
					controlFunc={props.addToForm}
					name={"patientSignDate"}
					inputType={"date"}
					value={props.consentForm.patientSignDate}
				/>
				<Signature 
					controlFunc={props.addToForm}
					name={"patientSignature"}
					value={props.consentForm.patientSignature}
				/>
			</div>

			<div className={classes.Section}>
				<SingleInput
					controlFunc={props.addToForm}
					name={"witnessSignDate"}
					inputType={"date"}
					value={props.consentForm.witnessSignDate}
				/>
				<label>Witness Signature:</label>
				<Signature 
					controlFunc={props.addToForm}
					name={"witnessSignature"}
					value={props.consentForm.witnessSignature}
				/>
			</div>
		</div>
	)
}

export default ModuleTwo


// WEBPACK FOOTER //
// ./src/components/Modules/2.js